import { ReactNode } from "react";
import { formatPeerDiff } from "../../constants/dashboardStats";
import "./InfoStatCard.scss";

type InfoStatCardProps = {
  label: ReactNode;
  labelInfo?: ReactNode;
  value: ReactNode;
  detail: string;
  footer?: ReactNode;
};

const InfoStatCard = ({ label, labelInfo, value, detail, footer }: InfoStatCardProps) => (
  <div className="info-stat-card">
    <div className="info-stat-card__label-row">
      <div className="info-stat-card__label">{label}</div>
      {labelInfo}
    </div>
    <div className="info-stat-card__value">{value}</div>
    <div className="info-stat-card__detail">{detail}</div>
    {footer}
  </div>
);

type InfoStatCardPeerRowProps = {
  peerAvg: number;
  score: number;
};

export const InfoStatCardPeerRow = ({ peerAvg, score }: InfoStatCardPeerRowProps) => {
  const { text, color } = formatPeerDiff(score, peerAvg);

  return (
    <div className="info-stat-card__peer-row">
      Peer avg: {peerAvg}% ·{" "}
      <span style={{ color, fontWeight: 500 }}>{text}</span> vs peers
    </div>
  );
};

export default InfoStatCard;
